import type { Maybe } from '../../../common/types';

export type KnowledgeDiscoveryJiraSearchClassificationType =
	(typeof KnowledgeDiscoveryJiraSearchClassification)[keyof typeof KnowledgeDiscoveryJiraSearchClassification];

/**
 * Search classification result containing the detected type.
 */
export type KnowledgeDiscoveryJiraSearchClassificationData = {
	/** The detected search classification type. */
	type?: Maybe<KnowledgeDiscoveryJiraSearchClassificationType>;
	/** The detected search classification pattern. */
	pattern?: Maybe<string>;
};

/**
 * Classification type for Jira search intent.
 */
export const KnowledgeDiscoveryJiraSearchClassification = {
	GNIN: 'GNIN',
	FPS: 'FPS',
} as const;
